import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

const s = {
  page: { minHeight: '100vh', background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' },
  box: { background: '#f8f8f8', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '24px', padding: '2.5rem', width: '100%', maxWidth: '420px' },
  logo: { fontFamily: 'Inter, ui-sans-serif, sans-serif', fontWeight: 800, fontSize: '2rem', color: '#111111', textAlign: 'center', marginBottom: '0.5rem' },
  tagline: { color: '#666680', fontSize: '0.9rem', textAlign: 'center', marginBottom: '2rem' },
  tabs: { display: 'flex', background: '#efefef', borderRadius: '10px', padding: '3px', marginBottom: '1.75rem' },
  tab: (active) => ({
    flex: 1, padding: '0.6rem', borderRadius: '7px', textAlign: 'center',
    fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s',
    background: active ? '#ffffff' : 'transparent',
    border: active ? '1px solid rgba(0,0,0,0.08)' : 'none',
    color: active ? '#111111' : '#666680',
  }),
  group: { marginBottom: '1rem' },
  label: { display: 'block', color: '#666680', fontSize: '0.8rem', fontWeight: 500, marginBottom: '0.4rem' },
  input: { width: '100%', padding: '0.75rem 1rem', background: '#ffffff', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '10px', color: '#111111', fontSize: '0.95rem', outline: 'none', transition: 'border-color 0.2s' },
  btn: { width: '100%', padding: '0.85rem', borderRadius: '10px', background: 'linear-gradient(135deg, #3a7d00, #1f4500)', color: '#fff', fontWeight: 700, fontSize: '1rem', marginTop: '0.5rem', border: 'none', cursor: 'pointer' },
  error: { background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.2)', borderRadius: '8px', padding: '0.75rem 1rem', color: '#dc2626', fontSize: '0.85rem', marginBottom: '1rem' },
  success: { background: 'rgba(58,125,0,0.08)', border: '1px solid rgba(58,125,0,0.2)', borderRadius: '8px', padding: '0.75rem 1rem', color: '#3a7d00', fontSize: '0.85rem', marginBottom: '1rem' },
  back: { display: 'block', textAlign: 'center', color: '#666680', fontSize: '0.85rem', marginTop: '1.25rem', cursor: 'pointer' },
};

export default function Auth() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    setError(''); setSuccess(''); setLoading(true);
    try {
      if (mode === 'login') {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        navigate('/');
      } else {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setSuccess('Account created! Check your email to confirm, then log in.');
      }
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div style={s.page}>
      <div style={s.box}>
        <div style={s.logo}>MacRO</div>
        <div style={s.tagline}>Track your fast food macros smarter</div>
        <div style={s.tabs}>
          <div style={s.tab(mode === 'login')} onClick={() => { setMode('login'); setError(''); setSuccess(''); }}>Log In</div>
          <div style={s.tab(mode === 'signup')} onClick={() => { setMode('signup'); setError(''); setSuccess(''); }}>Sign Up</div>
        </div>
        {error && <div style={s.error}>{error}</div>}
        {success && <div style={s.success}>{success}</div>}
        <div style={s.group}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} onFocus={e => e.target.style.borderColor = '#3a7d00'} onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.12)'} />
        </div>
        <div style={s.group}>
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()} onFocus={e => e.target.style.borderColor = '#3a7d00'} onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.12)'} />
        </div>
        <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Loading...' : mode === 'login' ? 'Log In' : 'Create Account'}
        </button>
        <span style={s.back} onClick={() => navigate('/')}>← Back to MacRO</span>
      </div>
    </div>
  );
}